import { render, staticRenderFns } from "./AggregateType.vue?vue&type=template&id=39539052&scoped=true"
import script from "./AggregateType.vue?vue&type=script&lang=js"
export * from "./AggregateType.vue?vue&type=script&lang=js"
import style0 from "./AggregateType.vue?vue&type=style&index=0&id=39539052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39539052",
  null
  
)

export default component.exports